'use client';

import { useState } from 'react';
import { cn } from '@/lib/utils';

const WELL_KNOWN_ADDRESSES: Record<string, string> = {
  USDC: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
  WETH: '0x4200000000000000000000000000000000000006',
  ETH: '0x0000000000000000000000000000000000000000',
};

interface TokenIconProps {
  address?: string;
  symbol: string;
  className?: string;
}

export function TokenIcon({ address, symbol, className }: TokenIconProps) {
  const resolvedAddress = address || WELL_KNOWN_ADDRESSES[symbol];
  const [failed, setFailed] = useState(false);
  const showFallback = !resolvedAddress || failed;

  if (showFallback) {
    return (
      <span
        className={cn(
          'inline-flex items-center justify-center rounded-full bg-muted border border-border/50 text-[8px] font-bold text-muted-foreground shrink-0',
          className,
        )}
      >
        {symbol.slice(0, 2)}
      </span>
    );
  }

  return (
    <img
      src={`/api/token-icon/${resolvedAddress}`}
      alt={symbol}
      className={cn('rounded-full shrink-0', className)}
      onLoad={(e) => {
        const img = e.currentTarget;
        if (img.naturalWidth <= 1 && img.naturalHeight <= 1) setFailed(true);
      }}
      onError={() => setFailed(true)}
    />
  );
}
